import React from "react";
import api from "src/store/features/api";
import {
  ISummaryData,
  ITimePeriodOption,
  TIME_PERIOD_OPTIONS,
  TIME_PERIOD_OPTIONS_HOWTO,
} from "./defaults";
import PortfolioSummary from "./summary/PortfolioSummary";
import SummaryDefault from "./summary/SummaryDefault";
import { useUserSlice } from "src/store/features/user.slice";
import useIsUkUserCountry from "src/utils/hooks/useIsUkUserCountry";

const Summary = () => {
  const { isUnverified } = useUserSlice();
  const isUkUser = useIsUkUserCountry();

  const [howtos, setHowtos] = React.useState<string>("How to");
  const handleHowTos = (newOpt: ITimePeriodOption): void => {
    setHowtos(newOpt.label);

    // link to how to articles
    window.open(newOpt.link, "_blank");
  };

  const [timePeriod, setTimePeriod] = React.useState<string>(TIME_PERIOD_OPTIONS[4].name);
  const [timePeriodValue, setTimePeriodValue] = React.useState<ITimePeriodOption["value"]>(
    TIME_PERIOD_OPTIONS[4].value,
  );
  const handleTimePeriod = (newOpt: ITimePeriodOption): void => {
    setTimePeriod(newOpt.label);
    setTimePeriodValue(newOpt.value);
  };

  // call api here
  // get summary data - targets, trades, portfolio, referrals.
  const {
    data: summary,
    isLoading,
    isFetching,
  } = api.useGetUserSummaryQuery({ timeFrame: timePeriodValue });

  // format data from BE for balance component
  const data = React.useMemo((): ISummaryData[] => {
    if (!summary) return [];
    return summary
      .filter((item) => !(isUkUser && item.type.toLowerCase() === "referrals"))
      .map((item) => ({
        type: item.type,
        value: item.value,
      }));
  }, [summary, isUkUser]);

  // no summary data
  const SHOW_DEFAULT = isLoading || data.every((sum) => sum.value === 0) || isUnverified;

  return (
    <>
      {isUnverified || SHOW_DEFAULT ? ( // IS UNVERIFIED or BLANK VERIFIED ACCOUNT
        <SummaryDefault
          isLoading={isLoading}
          timePeriodOptions={TIME_PERIOD_OPTIONS_HOWTO}
          howtos={howtos}
          handleHowTos={handleHowTos}
        />
      ) : (
        <PortfolioSummary
          data={data}
          timePeriodOptions={TIME_PERIOD_OPTIONS}
          timePeriod={timePeriod}
          handleTimePeriod={handleTimePeriod}
          isFetching={isFetching}
        />
      )}
    </>
  );
};

export default Summary;
